export default "__VITE_ASSET__3bcaa75b__"